module.exports = {
  id: {
    label: 'ID',
    type: 'number',
    required: true,
    disabled: {
      edit: true,
    },
    hidden: {
      add: true,
      edit: true,
    },
  },
  property_id: {
    label: 'Lot #',
    hint: 'Start typing and select a property from the dropdown',
    type: 'autocomplete',
    itemsEndpoint: '/properties/personal/list',
    required: true,
  },
  check_in: {
    label: 'Check in',
    type: 'date',
    required: true,
    // inFuture: true,
  },
  check_out: {
    label: 'Check out',
    type: 'date',
    required: true,
    // inFuture: true,
  },
  nights: {
    label: '# of nights: ',
    type: 'calculated',
    calc: 'difference',
    termType: 'date',
    terms: ['check_out', 'check_in'],
    resultUnit: 'day',
  },
  f_and_f: {
    label: 'Non-Paying Family & Friends',
    type: 'switch',
  },
  guests: {
    label: 'Renter',
    type: 'list',
    hint: 'Name of PAYING renter or name of non-paying family/ friends. All fields are required.',
    template: {
      fname: {
        label: 'First Name',
        rules: [
          v => v && v !== '' && /[A-Za-z]+/.test(v) || 'First name is required',
          v => v && v.length <= 128 || 'First name must be less than 129 characters',
        ]
      },
      lname: {
        label: 'Last Name',
        rules: [
          v => v && v !== '' && /[A-Za-z]+/.test(v) || 'Last name is required',
          v => v && v.length <= 128 || 'Last name must be less than 129 characters',
        ]
      },
    },
    min: 1
  },
  vehicles: {
    label: 'Vehicles',
    type: 'list',
    hint: 'List all vehicles entering the property. All fields are required.',
    template: {
      make: {
        label: 'Make',
        rules: [
          v => v && v !== '' && /[A-Za-z]+/.test(v) || 'Make is required',
          v => v && v.length <= 32 || 'Make must be less than 33 characters',
        ]
      },
      model: {
        label: 'Model',
        rules: [
          v => v && v !== '' && /[A-Za-z]+/.test(v) || 'Model is required',
          v => v && v.length <= 32 || 'Model must be less than 33 characters',
        ]
      },
      license_plate: {
        label: 'License Plate #',
        rules: [
          v => v && v !== '' && /[0-9A-Za-z]+/.test(v) || 'License plate is required',
          v => v && v.length <= 10 || 'License plate must be less than 11 characters',
        ]
      },
      region: {
        label: 'State/Province',
        rules: [
          v => v && v !== '' && /[A-Za-z]+/.test(v) || 'State/Province is required',
          v => v && v.length <= 64 || 'State/Province must be less than 65 characters',
        ]
      }
    },
    min: 1,
  },
  amount: {
    label: 'Fee Total: ',
    type: 'if',
    terms: ['f_and_f', 'nights'],
    op: ['==', '<'],
    exp: [false, 30],
    prepend: '$',
    return: ['25', '0'],
  },
}
